import { topLevelElements } from './watchContent';
export default function commentBodies(vnode) {
  if (this.attrs.isEditing) return [];
  const body = topLevelElements(vnode).find(element => element.classList.contains('Post-body'));
  if (!body || isConcealed(body)) return [];
  return [body];
}
function isConcealed(body) {
  return body.closest('.Post--hidden:not(.revealContent)') !== null;
}
flarum.reg.add('datlechin-link-preview', 'forum/utils/commentBodies', commentBodies);